export default __webpack_public_path__ + "fe55e6baaadd21dae3d5973372c8cb09.svg";